export const depositSuccessState = {
  title: 'Deposit success',
  icon: 'icon-terminal-deposit-success',
  description: 'Your deposit has been successfully made',
};

export const withdrawSuccessState = {
  title: 'Withdrawal Success',
  icon: 'icon-terminal-withdraw',
  description: 'Your withdraw has been successfully made',
};

export const depositSearchPlayer = {
  title: 'Deposit',
  description: 'Enter your ID or login to make a deposit',
};

export const withdrawSearchPlayer = {
  title: 'Withdraw',
  description: 'Enter your id or login to make a withdraw',
};
